export const URL = '/v2/pms/accomodations/:placeId/room_categories/:categoryId/'

export type Req = void

export type Resp = any